import { GlobalThemeOverrides } from "naive-ui";
const lightTheme = {
	blueGradientFrom: "#5d63fb",
	blueGradientTo: "#444bf5",
	gs100: "#1C1C1C",
	gs200: "#585757",
	gs300: "#969696",
	gs400: "#E8E8E8",

	blue: "#0085ff",
	green: "#00ba34",
	orange: "#f98600",
	red: "#e92c2c",
	bgPrimary: "#ffffff",
	bgSecondary: "#f7f7f7",
	bgBlue: "#eeefff",
	bgGreen: "#e6f9eb",
	bgOrange: "#fff5e9",
	bgRed: "#ffecec",
};

const themeOverrides: GlobalThemeOverrides = {
	common: {
		primaryColor: lightTheme.blueGradientFrom,
		primaryColorHover: lightTheme.blueGradientTo,
		primaryColorPressed: lightTheme.blueGradientTo,
		primaryColorSuppl: lightTheme.blueGradientTo,
		// borderRadius: '8px',
	},
	Button: {
		// textColor: 'red',
		borderRadiusMedium: "8px",
		heightMedium: "50px",
	},
	Input: {
		borderRadius: "8px",
		heightMedium: "40px",
	},
	Select: {
		borderRadius: "8px",
		peers: {
			InternalSelection: {
				borderRadius: "8px",
				heightMedium: "40px",
			},
		},
	},
	Tabs: { tabBorderRadius: "8px" },
	Checkbox: {
		borderRadius: "4px",
	},
};

export default themeOverrides;
